export const ESIM_UPGRADE_RETURN_FROM_QR_KEY = 'esimUpgradeReturnFromQr';
export const ESIM_UPGRADE_RETURN_URL_KEY = 'esimUpgradeReturnUrl';
